import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./homeClient.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Cookies from 'js-cookie';
import { decryptData } from "../../Auth/cryptage";



function HomeClient({ logout }) {
    const user = JSON.parse(decryptData(Cookies.get('user')));
    const resources = JSON.parse(decryptData(Cookies.get('resources')));
    useEffect(() => {
        document.title = "GecimmoIA - Home";
    },[]); 
    useEffect(() => {
        AOS.init({ duration: 1200 });
    }, []);
    return (
        <Container fluid className="full-height">
            <Row>
                <Col>
                    <h1 className="welcometext mt-5 mb-5">Bienvenu Mr. <span className="welcometextspan">{user.name} {user.prenom}</span></h1>
                </Col>
            </Row>
        
            <Row data-aos="fade-up" className="justify-content-center">
                {resources.map((resource, index) => (
                    <Col md={3} key={index} className="mb-4">
                        <Link  to={`/fillter-data/${resource.name}/${resource.typeR}`} className="d-flex justify-content-center">
                            <Card className="Resource w-100">
                                <Card.Body className="text-center">
                                    <Card.Title >{resource.name}</Card.Title>
                                </Card.Body>
                            </Card>
                        </Link>
                    </Col>
                ))}
            </Row>
        </Container>
    );
}

export default HomeClient;
